"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uploadFile;

var _getSignedUrl = _interopRequireWildcard(require("./queries/getSignedUrl"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/** @module uploadFile */

/* Retrieve S3 URL from the network */


function getS3Url(_x) {
  return _getS3Url.apply(this, arguments);
}
/**
 * Uploads a file to a S3 bucket
 *
 * @param {*} file
 *
 * @return {Promise<*>}
 */


function _getS3Url() {
  _getS3Url = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var apiClient, bucketKey, action, organisationId, _ref3, getS3SignedUrl, _ref4, data, errors;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiClient = _ref.apiClient, bucketKey = _ref.bucketKey, action = _ref.action, organisationId = _ref.organisationId;

            if (organisationId) {
              _context.next = 3;
              break;
            }

            throw new Error('You must either provide an organisationId or there must be a selected organisation to upload a file.');

          case 3:
            if (!apiClient.request) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return apiClient.request(_getSignedUrl.getSignedUrlQuery, {
              bucketKey: bucketKey,
              organisationId: organisationId,
              action: action
            });

          case 6:
            _ref3 = _context.sent;
            getS3SignedUrl = _ref3.getS3SignedUrl;
            return _context.abrupt("return", getS3SignedUrl);

          case 9:
            _context.next = 11;
            return apiClient.query({
              variables: {
                action: action,
                bucketKey: bucketKey,
                organisationId: organisationId
              },
              query: _getSignedUrl.default,
              context: {
                module: 'assets'
              }
            });

          case 11:
            _ref4 = _context.sent;
            data = _ref4.data;
            errors = _ref4.errors;

            if (!(errors && errors.length)) {
              _context.next = 16;
              break;
            }

            throw new Error(errors[0].message);

          case 16:
            return _context.abrupt("return", data.getS3SignedUrl);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getS3Url.apply(this, arguments);
}

function uploadFile(_x2) {
  return _uploadFile.apply(this, arguments);
}

function _uploadFile() {
  _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var apiClient, file, bucketKey, organisationId, putUrl;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            apiClient = _ref2.apiClient, file = _ref2.file, bucketKey = _ref2.bucketKey, organisationId = _ref2.organisationId;

            if (apiClient) {
              _context2.next = 3;
              break;
            }

            throw new Error('Must provide an apollo API client');

          case 3:
            if (!(!file || !file.name)) {
              _context2.next = 5;
              break;
            }

            throw new Error('Must provide file name');

          case 5:
            _context2.next = 7;
            return getS3Url({
              apiClient: apiClient,
              bucketKey: bucketKey,
              action: 'put',
              organisationId: organisationId
            });

          case 7:
            putUrl = _context2.sent;
            _context2.next = 10;
            return fetch(putUrl, {
              method: 'PUT',
              body: file
            });

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _uploadFile.apply(this, arguments);
}